export default __webpack_public_path__ + "static/media/icons8-mastercard-logo.144d8872.svg";